import BannerStatic, { BannerType } from 'elem/compCommon/BannerStatic';
import { SceneEmail } from '@elem/compCommon/SceneEmail';
import EcoImg from 'eco-design/base/eco-img';
import css from './index.module.scss';
import { useGlobal } from '@/utils/useGlobal';

export default function A() {
    const { useLang, useRouter } = useGlobal();
    const { locale } = useRouter();
    const { t } = useLang('outdoorrecreation');
    const IS_NA = ['us', 'ca', 'au'].includes(locale);
    // UK属于英规
    const EU_SITES: string[] = ['eu', 'de', 'fr', 'it', 'es', 'cis', 'za', 'nl'];
    // 本地化图片
    const LOCAL_SITES: string[] = ['au', 'kr'];
    const data: BannerType = {
        src: `/responsive/picture/outdoor-recreation/1${EU_SITES.includes(locale) ? '_eu' : LOCAL_SITES?.includes(locale) ? `_${locale}` : ''}.jpg`,
        srcDesktop: `/responsive/picture/outdoor-recreation/1_1366${EU_SITES.includes(locale) ? '_eu' : LOCAL_SITES?.includes(locale) ? `_${locale}` : ''}.jpg`,
        srcPad: `/responsive/picture/outdoor-recreation/1_768${EU_SITES.includes(locale) ? '_eu' : LOCAL_SITES?.includes(locale) ? `_${locale}` : ''}.jpg`,
        srcMobile: `/responsive/picture/outdoor-recreation/1_768${EU_SITES.includes(locale) ? '_eu' : LOCAL_SITES?.includes(locale) ? `_${locale}` : ''}.jpg`,
        alt: t('secA_title'),
        title: t('secA_title'),
        desc: t('secA_desc'),
        btnText: t('secA_btn'),
        link: '#outdoor-recreation-C',
        theme: 'black',
    };
    if (locale === 'us' || locale === 'ca') {
        // data.src = 'https://websiteoss.ecoflow.com/upload/image/1747800086627/kv_na.jpg';
        data.src = 'https://websiteoss.ecoflow.com/upload/image/1747821766082/na_pc.jpg';
        data.srcDesktop = 'https://websiteoss.ecoflow.com/upload/image/1747821766082/na_pc.jpg';
        data.srcPad = 'https://websiteoss.ecoflow.com/upload/image/1748242396958/kv_na_pad.jpg';
        data.srcMobile = 'https://websiteoss.ecoflow.com/upload/image/1748242399966/kv_na_h5.jpg';
        data.theme = 'black';
    }
    if (locale === 'au') {
        data.src = 'https://websiteoss.ecoflow.com/figma-uploads/1785322898337-mnu7gn-compressed-outdoor%20campagin-banner.webp';
        data.srcDesktop = 'https://websiteoss.ecoflow.com/figma-uploads/1785322898337-mnu7gn-compressed-outdoor%20campagin-banner.webp';
        data.srcPad = 'https://websiteoss.ecoflow.com/figma-uploads/1785322940324-aa2bks-compressed-home-carousel-banner.webp';
        data.srcMobile = 'https://websiteoss.ecoflow.com/figma-uploads/1785322963165-vgshd2-compressed-home-carousel-banner.webp';
        data.theme = 'white';
    }
    if (locale === 'za') {
        data.src = 'https://ecoflow-service-us-cdn.ecoflow.com/upload/image/1717578505675/kv_za_1366.png';
        data.srcDesktop = 'https://ecoflow-service-us-cdn.ecoflow.com/upload/image/1717578505675/kv_za_1366.png';
    }
    const IS_AU = locale === 'au';
    return (
        <div className={`outdoor-recreation-A ${css['outdoor-recreation-A']}`}>
            {IS_NA ? (
                <>
                    <EcoImg pc={data.srcDesktop} pad={data.srcPad} h5={data.srcMobile} alt={t('secA_title')} aria-label={t('secA_title')} />
                    <div className={`info${IS_AU ? ' info-au' : ''}`}>
                        <p className="title">{t('secA_title')}</p>
                        <SceneEmail
                            theme={data.theme === 'black' ? 'black' : 'white'}
                            align={IS_AU ? 'left' : 'center'}
                            type="OUTDOOR_RECRATION"
                            title={t('secA_title')}
                            description={IS_AU ? t('scene_email_text') : undefined}
                            subscribeData={
                                IS_AU
                                    ? {
                                          source: 'WEB_NEW_PRODUCT_SUB',
                                          contactListId: '1388453392',
                                          fields: [
                                              { type: 'single', id: '4433', value: 1, overwrite: true },
                                              { type: 'single', id: '31', value: 1, overwrite: true },
                                              { type: 'multiple', id: '9537', value: [11], overwrite: false },
                                          ],
                                      }
                                    : undefined
                            }
                        />
                    </div>
                </>
            ) : (
                <BannerStatic {...data} />
            )}
        </div>
    );
}
